import * as React from "react"
import { Container } from "react-grid-system"

const PageContentWrapper: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  return <Container style={{ maxWidth: "830px" }}>{children}</Container>
}

export default PageContentWrapper
